<template>
  <v-layout class="small-book-form" column align-content-start style="height: 100%">
    <v-flex>
      <v-flex>
        <BusinessCustomerDetailsInput :bookingForm="bookingForm" hideAuthorizedBy="true" />
      </v-flex>
      <v-flex px-2 pb-1>
        <v-layout row>
          <v-divider style="margin-left: 12px;  margin-bottom: 5px;"></v-divider>
        </v-layout>
      </v-flex>
      <v-layout px-1 row wrap align-start>
        <v-flex md6>
          <BookingLocationInput
            flatField
            @locationChanged="pickupUpdated"
            v-model="bookingForm.booking.pickup_location"
            label="Pickup Location"
            :id="keyName+'pickup'"
            :error="bookingForm.errors.pickup_location"
          />
        </v-flex>
        <v-icon
          style="padding-left: 4px;"
          v-if="!pickupInfoActive()"
          class="add-person-button"
          v-on:click="function(){activatePickupInfo()}"
        >person_add</v-icon>
        <v-flex px-1 xs6 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.name"
            label="Name"
            :error="bookingForm.errors.pickup_info"
          />
        </v-flex>
        <v-flex px-1 xs6 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.contact_number"
            label="Contact No."
          />
        </v-flex>
        <v-flex px-1 xs12 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.notes"
            label="Notes"
            :maxlength="300"
          />
        </v-flex>
      </v-layout>
      <v-layout pl-1 pr-1 pt-1 row wrap align-start justify-start>
        <v-flex xs12 v-for="(destination, index) in bookingForm.booking.destinations">
          <v-layout py-1 align-start row wrap v-if="index > 0">
            <v-flex xs11 md6>
              <BookingLocationInput
                flatField
                :removable="true"
                @locationChanged="viaUpdated"
                v-model="bookingForm.booking.destinations[index]"
                :id="keyName+'destination'+index"
                :deletable="index > 0"
                @removePressed="function(){removeVia(index)}"
                :label="index == 0 ? 'Destination' : 'Via ' + index "
                :error="bookingForm.errors[`destination_${index}`]"
              />
            </v-flex>
            <v-icon
              v-if="!viaActive(bookingForm.booking.via_info[index-1])"
              class="add-person-button"
              v-on:click="function(){activateViaInfo(index)}"
            >person_add</v-icon>
            <v-flex px-1 v-if="viaActive(bookingForm.booking.via_info[index-1])" xs6 md2>
              <SimpleTextInput
                v-model="bookingForm.booking.via_info[index-1].name"
                label="Name"
                :error="bookingForm.errors[`via_info_${index-1}`]"
              />
            </v-flex>
            <v-flex px-1 v-if="viaActive(bookingForm.booking.via_info[index-1])" xs6 md2>
              <SimpleTextInput
                v-model="bookingForm.booking.via_info[index-1].contact_number"
                label="Contact No."
              />
            </v-flex>
            <v-flex px-1 v-if="viaActive(bookingForm.booking.via_info[index-1])" xs12 md2>
              <SimpleTextInput
                v-model="bookingForm.booking.via_info[index-1].notes"
                label="Notes"
                :maxlength="300"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout px-1 row wrap align-start>
        <v-flex md6 pt-2>
          <BookingLocationInput
            flatField
            @locationChanged="destinationUpdated"
            v-model="bookingForm.booking.destinations[0]"
            label="Destination Location"
            :id="keyName+'destination'"
            :error="bookingForm.errors['destination_0']"
          />
        </v-flex>
        <v-flex pt-2 v-if="!destinationInfoActive()">
          <v-icon
            style="padding-left: 4px;"
            class="add-person-button"
            v-on:click="function(){activateDestinationInfo()}"
          >person_add</v-icon>
        </v-flex>
        <v-flex px-1 v-if="destinationInfoActive()" xs6 md2 pt-2>
          <SimpleTextInput
            v-model="bookingForm.booking.destination_info.name"
            label="Name"
            :error="bookingForm.errors.destination_info"
          />
        </v-flex>
        <v-flex px-1 v-if="destinationInfoActive()" xs6 md2 pt-2>
          <SimpleTextInput
            v-model="bookingForm.booking.destination_info.contact_number"
            label="Contact No."
          />
        </v-flex>
        <v-flex px-1 pt-2 md2>
          <SimpleTextInput
            v-if="destinationInfoActive()"
            v-model="bookingForm.booking.destination_info.notes"
            label="Notes"
            :maxlength="300"
          />
        </v-flex>
      </v-layout>
      <v-layout px-1 pr-2 row wrap justify-end style="width: 100%;">
        <v-btn @click="addVia()" small flat class="text-none">+ Via</v-btn>
      </v-layout>
      <v-flex px-2 pt-2>
        <v-layout row>
          <v-divider style="margin-left: 12px; margin-top: 2px;"></v-divider>
        </v-layout>
      </v-flex>
      <v-flex pt-1>
        <VehicleRequirementsInput :bookingForm="bookingForm" />
      </v-flex>
      <v-flex>
        <PassengerFindDetails :bookingForm="bookingForm" />
      </v-flex>
      <v-flex>
        <BookingDispatchInput :bookingForm="bookingForm" />
      </v-flex>
      <v-flex px-2>
        <v-layout row>
          <v-divider style="margin-left: 12px; margin-top: 2px;"></v-divider>
        </v-layout>
      </v-flex>
      <v-flex pt-1>
        <PaymentInput :bookingForm="bookingForm" :hideAdditionalCharge="true" />
      </v-flex>
      <v-flex>
        <UserNotes :bookingForm="bookingForm" :hideCustomer="true" />
      </v-flex>
    </v-flex>
    <RepeatTripOptions
      @update="update"
      @create="create"
      @addReturnTrip="addReturnTrip"
      @cancel="cancel"
      @alter="alter"
      :repeatService="repeatService"
      :updateMode="updateMode"
      :bookingForm="bookingForm"
      :alterMode="alterMode"
      :loading="loading"
      :repeatTripDefinition="repeatTripDefinition"
    />
  </v-layout>
</template>

<script>
import { Overwatch } from "@/components/util/Overwatch.js";

import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import BookingDateTimeInput from "@/components/widget/input/BookingDateTimeInput.vue";

import BookingDispatchInput from "@/components/widget/input/BookingDispatchInput.vue";
import BookRideOptions from "@/components/widget/input/BookRideOptions.vue";
import BusinessCustomerDetailsInput from "@/components/widget/input/BusinessCustomerDetailsInput.vue";
import VehicleRequirementsInput from "@/components/widget/input/VehicleRequirementsInput.vue";
import PassengerFindDetails from "@/components/widget/input/PassengerFindDetails.vue";
import PaymentInput from "@/components/widget/input/PaymentInput.vue";
import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import CustomerSearchInput from "@/components/widget/input/CustomerSearchInput.vue";
import UserNotes from "@/components/widget/input/UserNotes.vue";
import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import RepeatTripOptions from "@/components/repeat_service/RepeatTripOptions.vue";

export default {
  name: "TripForm",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingLocationInput,
    SimpleTextInput,
    BookingDispatchInput,
    SelectableInput,
    BookingDateTimeInput,
    BusinessCustomerDetailsInput,
    VehicleRequirementsInput,
    PassengerFindDetails,
    PaymentInput,
    CustomerSearchInput,
    UserNotes,
    BookTripETARoute,
    CardInput,
    PromocodeInput,
    RepeatTripOptions
  },
  props: {
    repeatTripDefinition: Object,
    bookingForm: Object,
    repeatService: Object,
    expand: Function,
    updateMode: {
      type: Boolean,
      default: false
    },
    alterMode: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    keyName: String
  },
  computed: {
    userIsBusiness: function() {
      console.log("User is business " + this.bookingForm.user.business == true);
      return this.bookingForm.user.business == true;
    },
    viaCount: function() {
      var count = 0;

      for (var i = 1; i < this.bookingForm.booking.destinations.length; i++) {
        if (this.bookingForm.booking.destinations[i].id != null) {
          count++;
        }
      }

      return count;
    }
  },
  data() {
    return {
      addingCard: false,
      addingPromocode: false
    };
  },
  methods: {
    cancel: function() {
      this.$emit("cancel", null);
    },
    addReturnTrip: function() {
      this.$emit("addReturnTrip", null);
    },
    create: function() {
      if (this.bookingForm.validateRide()) {
        this.$emit("create", null);
      }
    },
    alter: function() {
      if (this.bookingForm.validateRide()) {
        this.$emit("alter", null);
      }
    },
    update: function() {
      if (this.bookingForm.validateRide()) {
        this.$emit("update", null);
      }
    },
    activatePickupInfo: function() {
      this.bookingForm.booking.pickup_info.active = true;
    },
    pickupInfoActive: function() {
      return (
        this.bookingForm.booking.pickup_info != null &&
        this.bookingForm.booking.pickup_info.active == true
      );
    },
    activateDestinationInfo: function() {
      this.bookingForm.booking.destination_info.active = true;
    },
    destinationInfoActive: function() {
      return (
        this.bookingForm.booking.destination_info != null &&
        this.bookingForm.booking.destination_info.active == true
      );
    },
    addVia: function() {
      this.bookingForm.addVia();
    },
    getCostEstimate: function(loc) {
      console.log("Get cost estimate smallbookform");
      this.bookingForm.getCostEstimate();
    },
    pickupUpdated: function(loc) {
      this.bookingForm.booking.pickup_location = loc;
      this.getCostEstimate();

      // this.centerToBooking();
      // this.$emit("locationsChanged", "");
    },
    destinationUpdated: function(loc) {
      this.bookingForm.booking.destinations[0] = loc;
      this.getCostEstimate();

      // this.centerToBooking();
      // this.$emit("locationsChanged", "");
    },
    viaUpdated: function(loc) {
      // this.centerToBooking();
      // this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    viaActive: function(via) {
      return via.active != null && via.active == true;
    },
    removeVia: function(index) {
      this.bookingForm.booking.destinations.splice(index, 1);
      this.bookingForm.booking.via_info.splice(index - 1, 1);

      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activateViaInfo: function(index) {
      this.bookingForm.booking.via_info[index - 1].active = true;
      this.$forceUpdate();
    },
    changePaymentTypeToCardWithToken(token) {
      this.addingCard = false;
      this.bookingForm.changePaymentType("card", token.card.id);
    },
    changePromocode(promocode) {
      this.addingPromocode = false;
      this.bookingForm.changePromocode(promocode);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.v-input--selection-controls {
  margin-top: 6px !important;
  padding-top: 0px !important;
}

.bottom-trip-info {
  background-color: #cccccc;
  height: 28px;
  min-height: 28px !important;
  border-radius: 8px;
  padding-left: 18px;
  padding-right: 18px;
  font-weight: 500;
  font-size: 12px;
}

.v-input__append-outer {
  padding-left: 0px !important;
  margin-left: 0px !important;
}

.small-button {
  font-size: 12px !important;
}
</style>
